export default __webpack_public_path__ + "static/media/330_dummy2016-physiotherapie01-de.729a180c.png";